module.exports = __webpack_public_path__ + "static/media/nem-bw.879f8506.jpg";